import React from 'react';
import { useBrand } from '|/brand';
import { ReviewSummaryResponse } from '|/services/purchase-api';
import OrderSummaryCio from './cio';
import OrderSummaryControl from './control';
import OrderSummarySlate from './slate';

interface OrderSummaryProps {
  summary: ReviewSummaryResponse;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  isCheckoutPage: boolean;
  onEditOrder: () => Promise<void>;
  // The checkout route renders the CIO summary unconditionally today, while the steps route
  // falls back to the pre-check-it-out one — so the arm differs by mount point.
  isCheckItOutTreatment: boolean;
}

const OrderSummary = ({ isCheckItOutTreatment, ...props }: OrderSummaryProps) => {
  const { brand } = useBrand();

  if (isCheckItOutTreatment) {
    // Slate keeps the pre-snapshot sheet until its own redesign ships.
    return brand === 'slate' ? <OrderSummarySlate {...props} /> : <OrderSummaryCio {...props} />;
  }

  return (
    <OrderSummaryControl
      isOpen={props.isOpen}
      setIsOpen={props.setIsOpen}
      summary={props.summary}
    />
  );
};

export default OrderSummary;
